import { InjectableClass } from '@fino/lib-injection';

export class InputFormService extends InjectableClass {
  constructor(fdFormControlTypes) {
    'ngInject';
    super({ fdFormControlTypes });
  }

  getFieldType(field) {
    if (field.type === 'iban' && this.isReadonly) {
      return 'text';
    }
    return field.type;
  }

  getFields(fields, languageOptions, model) {
    return fields.map((field) => {

      // Initialize field messages
      field.messages = {};

      // Set default error message for required fields
      if (field.required) {
        field.messages.required = 'app.form.error.message.required';
      }

      // Set validate specific messages
      if (field.options && field.options.validate) {
        let key = field.options.validate;
        field.messages[key] = `app.form.error.message.${key}`;
      }

      // Set type specific field configurations
      switch (field.type) {
        case this.fdFormControlTypes.DATE: {
          field.typeOptions = angular.extend({}, languageOptions, field.typeOptions);
          field.messages.date = 'app.form.error.message.date';
          break;
        }
        case this.fdFormControlTypes.SELECT: {
          if (field.typeOptions.defaultValue) {
            model[field.name] = field.typeOptions.defaultValue;
          }
          break;
        }
      }

      return field;
    });
  }

  isFieldReadonly(field) {
    if (angular.isDefined(this.isReadonly)) {
      return this.isReadonly;
    }
    return field.readonly;
  }
}
